import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Mantenimiento", -1)
const _hoisted_4 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_5 = {
  key: 0,
  class: "card-toolbar",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "Click to add a user"
}
const _hoisted_6 = {
  href: "#",
  class: "btn btn-sm btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_invite_friends"
}
const _hoisted_7 = { class: "svg-icon svg-icon-3" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" New Member ")
const _hoisted_9 = { class: "card-body py-3" }
const _hoisted_10 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_11 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Usuario Final"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-140px" }, "Dirección Mac'"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-120px" }, "Desc. Error")
  ])
], -1)
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "symbol symbol-45px me-5" }
const _hoisted_15 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_16 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary fs-6"
}
const _hoisted_17 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_18 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block fs-6"
}
const _hoisted_19 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "d-flex flex-column w-100 me-2" }
const _hoisted_22 = { class: "d-flex flex-stack mb-2" }
const _hoisted_23 = { class: "text-muted me-2 fs-7 fw-bold" }
const _hoisted_24 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "alert alert-success" }, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-2hx svg-icon-success me-3" }, [
    /*#__PURE__*/_createVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      width: "24px",
      height: "24px",
      viewBox: "0 0 24 24",
      version: "1.1"
    }, [
      /*#__PURE__*/_createVNode("g", {
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
      }, [
        /*#__PURE__*/_createVNode("rect", {
          x: "0",
          y: "0",
          width: "24",
          height: "24"
        }),
        /*#__PURE__*/_createVNode("path", {
          d: "M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z",
          fill: "#000000",
          opacity: "0.3"
        }),
        /*#__PURE__*/_createVNode("path", {
          d: "M11.1750002,14.75 C10.9354169,14.75 10.6958335,14.6541667 10.5041669,14.4625 L8.58750019,12.5458333 C8.20416686,12.1625 8.20416686,11.5875 8.58750019,11.2041667 C8.97083352,10.8208333 9.59375019,10.8208333 9.92916686,11.2041667 L11.1750002,12.45 L14.3375002,9.2875 C14.7208335,8.90416667 15.2958335,8.90416667 15.6791669,9.2875 C16.0625002,9.67083333 16.0625002,10.2458333 15.6791669,10.6291667 L11.8458335,14.4625 C11.6541669,14.6541667 11.4145835,14.75 11.1750002,14.75 Z",
          fill: "#000000"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createVNode("h5", { class: "mb-1" }, "¡Estás de enhorabuena!"),
    /*#__PURE__*/_createVNode("span", null, "Ninguno de tus dispositivos por el momento necesitan mantenimiento.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", {
    class: ["card", _ctx.widgetClasses]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h3", _hoisted_2, [
        _hoisted_3,
        _createVNode("span", _hoisted_4, "Necesitan atención " + _toDisplayString(_ctx.list.length) + " dispositivo/s ", 1)
      ]),
      (_ctx.BtnVisible)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("a", _hoisted_6, [
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Add-user.svg" })
              ]),
              _hoisted_8
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_9, [
      (_ctx.list.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode("table", _hoisted_11, [
              _hoisted_12,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("img", {
                            src: item.image,
                            alt: ""
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("a", _hoisted_16, _toDisplayString(item.name), 1),
                          _createVNode("span", _hoisted_17, _toDisplayString(item.email), 1)
                        ])
                      ])
                    ]),
                    _createVNode("td", null, [
                      _createVNode("a", _hoisted_18, _toDisplayString(item.mac), 1),
                      _createVNode("span", _hoisted_19, _toDisplayString(item.model), 1)
                    ]),
                    _createVNode("td", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _createVNode("div", _hoisted_22, [
                          _createVNode("span", _hoisted_23, _toDisplayString(item.error), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_24, [
            _hoisted_25
          ]))
    ])
  ], 2))
}